// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getQuarter as fn } from "../getQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getQuarter = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getQuarter;
